import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ClanTaskInfo, RaidState} from "@/store/clan/types";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import {AmountPanel} from "@/scenes.ui/amount-panel";
import {Amount} from "@/model/amount";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {StringUtils} from "@/utils/string-utils";

export class ClanRaidInfoPanel extends Phaser.GameObjects.Container {

    private static readonly INNER_BAR_WIDTH: number = 294;

    constructor(scene: Phaser.Scene, cti: ClanTaskInfo,
                initRaidClosedPanel: (cont: ClanRaidInfoPanel, posY: number) => unknown,
                initWaitingPanel: (cont: ClanRaidInfoPanel, posY: number) => unknown,
                toRaidCallback: () => unknown,
                fromRaidCallback: () => unknown) {
        super(scene);

        this.scene = scene;
        this.width = CU.CANVAS_WIDTH;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, 700 * CU.S);

        this.add(back);


        let clanTaskText = TextUtils.addTextAdvanced(scene, Tr('komandnoe.zadanie.segodnja'), 300, 30,
            '#d7d7d7', 12, 'normal', 480, 'center', 2, Fonts.ARIAL_MT);

        let sep = SpriteUtils.addSprite(this.scene, 300, clanTaskText.y / CU.S + 25, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.9, 0.6);

        let gainText = TextUtils.addTextAdvanced(scene, Tr('soberite'), 300, sep.y / CU.S + 30,
            '#979797', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let itemsText = TextUtils.addTextAdvanced(scene, cti.countRequired + ' ' + cti.itemName.toUpperCase(), 300, gainText.y / CU.S + 25,
            '#ffd747', 14, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let light = SpriteUtils.addSprite(this.scene, 300, itemsText.y / CU.S, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 4, 0.35);

        let inSnowWorldText = TextUtils.addTextAdvanced(scene, Tr('v.snezhnom.mire'), 300, itemsText.y / CU.S + 25,
            '#979797', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let itemIcon = SpriteUtils.addSprite(this.scene, 300, inSnowWorldText.y / CU.S + 45, Keys.ATLAS_GAINABLE_2, cti.itemId);

        let outerBar = SpriteUtils.addImage(this.scene, 150, itemIcon.y / CU.S + 35, Keys.ATLAS_UI, Keys.UI_TASK_PROGRESS_BAR_OUTER)
            .setOrigin(0, 0);

        let innerBar = SpriteUtils.addImage(this.scene, outerBar.x / CU.S + 3, outerBar.y / CU.S + 4, Keys.ATLAS_UI, Keys.UI_TASK_PROGRESS_BAR_INNER)
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(innerBar, ClanRaidInfoPanel.INNER_BAR_WIDTH * (cti.countCurr / cti.countRequired) * CU.S, 22 * CU.S);

        let completedText = TextUtils.addTextAdvanced(scene, Tr('vipolneno') + cti.countCurr + '/' + cti.countRequired, 300, innerBar.y / CU.S + 40,
            '#d7d7d7', 12, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let timeText = TextUtils.addTextAdvanced(scene, Tr('vremja.vipolnenija') + cti.raidStartTime + ' - ' + cti.raidEndTime, 300, completedText.y / CU.S + 30,
            '#a5a5a5', 10, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let nowText = TextUtils.addTextAdvanced(scene, Tr('seychas') + cti.nowTime + ')', 300, timeText.y / CU.S + 15,
            '#a5a5a5', 10, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let sep2 = SpriteUtils.addSprite(this.scene, 300, nowText.y / CU.S + 25, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.9, 0.6);

        let clanAwardPanel: AmountPanel = new AmountPanel(scene, 230 - ClanRaidInfoPanel.getElementsCount(cti.clanAward) * 35, sep2.y / CU.S + 20, Tr('nagrada.klanu'), cti.clanAward);

        let personalAwardPanel: AmountPanel = new AmountPanel(scene, 120, clanAwardPanel.y / CU.S + 30,
            StringUtils.formatString(Tr('voidite.v.top.n.i.polu4ite'), cti.personalAwardsCount).toUpperCase() + ': ', cti.personalAward);

        let yy = 0;
        let hasCompletedTask = cti.countCurr >= cti.countRequired;
        let taskCompletedPanelY = 0;

        if (hasCompletedTask) {
            let completedText = TextUtils.addTextAdvanced(scene, Tr('zadanie.vipolneno'), 300, personalAwardPanel.y / CU.S + 50,
                '#4fff27', 14, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_BOLD);
            this.add(completedText);
            let newTaskText = TextUtils.addTextAdvanced(scene, Tr('novoe.zadanie.nachnetsja.zavtra.v') + cti.raidStartTime,
                300, completedText.y / CU.S + 25, '#ffffff', 12, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);
            this.add(newTaskText);
            taskCompletedPanelY = newTaskText.y / CU.S;
        }

        if (cti.raidState === RaidState.IN_RAID) {
            let raidButton = new SquareButton(this.scene, 300,
                hasCompletedTask ? taskCompletedPanelY + 60 : personalAwardPanel.y / CU.S + 100,
                0, Keys.UI_ART_GREEN_BUTTON,
                Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('v.rodnoy.mir'), false);
            raidButton.setCallback(() => {
                fromRaidCallback();
            });
            this.add(raidButton);
            yy = raidButton.y / CU.S;
        } else if (cti.raidState === RaidState.RAID_AVAILABLE) {
            let raidButton = new SquareButton(this.scene, 300,
                hasCompletedTask ? taskCompletedPanelY + 90 : personalAwardPanel.y / CU.S + 100,
                0, Keys.UI_ART_GREEN_BUTTON,
                Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('v.snezhniy.mir'), false);
            raidButton.setCallback(() => {
                toRaidCallback();
            });

            this.add(raidButton);
            yy = raidButton.y / CU.S;
        } else if (cti.raidState === RaidState.RAID_WAITING) {
            initWaitingPanel(this,
                hasCompletedTask ? taskCompletedPanelY + 10 : personalAwardPanel.y / CU.S);
            yy = hasCompletedTask ? taskCompletedPanelY + 150 : personalAwardPanel.y / CU.S + 160;
        } else if (cti.raidState === RaidState.RAID_CLOSED) {
            initRaidClosedPanel(this,
                hasCompletedTask ? taskCompletedPanelY + 30 : personalAwardPanel.y / CU.S);
            yy = hasCompletedTask ? taskCompletedPanelY + 100 : personalAwardPanel.y / CU.S + 45;
        }

        let sep3 = SpriteUtils.addSprite(this.scene, 300,
            yy + (hasCompletedTask ? 125 : 105),
            Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.5, 0.3);
        let helpClanText = TextUtils.addTextAdvanced(scene, Tr('pomogite.svoemu.klanu.uchastvuyte.v.komandnom.zadanii'), 300,
            yy + (hasCompletedTask ? 175 : 155),
            '#e8dfcd', 11, 'normal', 500, 'center', 2, Fonts.ARIAL_MT);

        let helpTxt = Tr('v.komandnom.zadanii.uchastvujut.vse.chleni.klana.n') +
            Tr('kolichestvo.shagov.v.snezhnom.mire.ogranicheno.n') +
            Tr('otpravitsja.v.snezhniy') + cti.hoursGap +' ' + Tr('hrs') + '.';
        let helpText = TextUtils.addTextAdvanced(scene, helpTxt, 300, helpClanText.y / CU.S + 65,
            '#9a9a9a', 10, 'normal', 480, 'center', 2, Fonts.BENGALY_NORMAL);

        let sep4 = SpriteUtils.addSprite(this.scene, 300, helpText.y / CU.S + 55, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR);

        this.height = sep4.y / CU.S;

        this.add([light, helpClanText, clanTaskText, sep, gainText, itemsText, inSnowWorldText, itemIcon, innerBar, outerBar, sep2,
            completedText, timeText, nowText, clanAwardPanel, personalAwardPanel, helpText, sep3, sep4]);
    }

    private static getElementsCount(amount: Amount) {
        let count = 0;
        if (amount.gold > 0) {
            count += 1;
        }
        if (amount.crystal > 0) {
            count += 1;
        }
        if (amount.elixir > 0) {
            count += 1;
        }
        if (amount.mithril > 0) {
            count += 1;
        }
        return count;
    }

    private static formatAwardsCountWord(num: number): string {
        return num === 3 ? Tr('troyke') : (String(num) + Tr('ke'));
    }
}
